const DEFAULT_IGNORED_KEYS = new Set(['idempotencyKey', 'idempotency_key']);

const normalizeValue = (value: unknown, ignoredKeys: Set<string>): unknown => {
  if (Array.isArray(value)) {
    return value.map((entry) => normalizeValue(entry, ignoredKeys));
  }

  if (!value || typeof value !== 'object') return value;

  return Object.keys(value as Record<string, unknown>)
    .sort((left, right) => left.localeCompare(right))
    .reduce<Record<string, unknown>>((acc, key) => {
      if (ignoredKeys.has(key)) return acc;
      acc[key] = normalizeValue((value as Record<string, unknown>)[key], ignoredKeys);
      return acc;
    }, {});
};

const stableStringify = (value: unknown, ignoredKeys: Set<string>) =>
  JSON.stringify(normalizeValue(value, ignoredKeys));

const fnv1a = (value: string) => {
  let hash = 0x811c9dc5;
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 0x01000193);
  }
  return (hash >>> 0).toString(16).padStart(8, '0');
};

export const createIdempotencyKey = (
  prefix: string,
  payload: unknown,
  options: { ignoreKeys?: string[] } = {},
) => {
  const ignoredKeys = new Set(DEFAULT_IGNORED_KEYS);
  (options.ignoreKeys ?? []).forEach((key) => ignoredKeys.add(key));

  const serialized = stableStringify(payload, ignoredKeys);
  const normalizedPrefix = prefix.trim().replace(/[^a-z0-9_-]+/gi, '-').toLowerCase() || 'request';
  return `${normalizedPrefix}:${fnv1a(serialized)}:${serialized.length.toString(16)}`;
};